module.exports = __webpack_public_path__ + "img/sportage-19.f26bc8bf.png";